import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import InformationAccount from './InformationAccount';
import ChangePassword from './ChangePassword';

const Profile = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <Row>
                    <Col sm={12}>
                      <Breadcrumbs floor={[{ name: t('account') }]} />
                    </Col>
                  </Row>
                  <div className="page-header">
                    <div className="page-block"></div>
                  </div>
                  <Row>
                    <InformationAccount />
                    <ChangePassword />
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
